<template>
	<button class="scrollBtn" @click="scroll">
		<svg width="18px" height="11px" viewBox="0 0 18 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
			<title>Path 2</title>
			<desc>Created with Sketch.</desc>
			<g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g id="Module/FooterStroke" transform="translate(-1364.000000, -139.000000)" stroke="#FFFFFF" stroke-width="2">
					<polyline id="Path-2" transform="translate(1373.000000, 145.000000) rotate(-180.000000) translate(-1373.000000, -145.000000) " points="1365 141.00936 1372.99532 149 1381 141"></polyline>
				</g>
			</g>
		</svg>
	</button>
</template>

<script>
export default {
	methods: {
		scroll: function(){
			window.scroll({ top: 0, left: 0, behavior: 'smooth' });
		},	
	}
}
</script>

<style lang="scss" scoped>
	.scrollBtn{
		background-color: $dark-grey;
		border-radius: 100%;
		width: 60px;
		height: 60px;
	    bottom: 65px;
		right: 40px;
		color: $white;
		cursor: pointer;
		z-index: 10;
		border: none;
		position: absolute;
		svg{
			width: 40px;
    		height: 15px;
		}
		@include res(tab-p){
			display: none;
		}
	}
</style>
